import { Star } from "@mui/icons-material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { EvaluationStarsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationStarsSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: EvaluationStarsSubtypeDataModel;
}

export default function EvaluationStarsSubtypeDetails(props: Props) {
    return <>
        {[1, 2, 3, 4, 5].map(i =>
            <Star color={props.subtypeData.numberOfStars >= i ? "primary" : "secondary"} />)}
    </>
}